import { TYPES } from "../segments/FileSystem";

class Directory {
  #parent;
  #children;

  constructor(name, hash, parent, children) {
    this.#parent = parent;
    this.metadata = { name: name, hash: hash, type: TYPES.DIR };
    this.#children = children;
  }

  changeParent(parent) {
    this.#parent = parent;
  }

  changeName(name) {
    this.metadata.name = name;
  }

  addChild(hash, metadata) {
    this.#children[hash] = metadata;
  }

  removeChild(hash) {
    delete this.#children[hash];
  }

  getMetaData() {
    return this.metadata;
  }

  getType() {
    return this.metadata.type;
  }

  getName() {
    return this.metadata.name;
  }

  getHash() {
    return this.metadata.hash;
  }

  getParent() {
    return this.#parent;
  }

  getChildren() {
    return this.#children;
  }

  getChildrenCount() {
    return Object.keys(this.#children).length;
  }

  getChild(hash) {
    return this.#children[hash];
  }

  isBin() {
    return this.metadata.hash === "bin";
  }

  isRoot() {
    return this.metadata.hash === "root";
  }

  clone() {
    return new Directory(
      this.metadata.name,
      this.metadata.hash,
      this.#parent,
      this.#children
    );
  }
}

export default Directory;
